import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ScanMap } from './ScanMap';
import { HouseCard } from './HouseCard';
import type { House } from '../../types/house';
import type { ScanPhase } from '../../types/scan';
interface MapPanelProps {
  phase: ScanPhase;
  house: House | null;
  onEdit: () => void;
}
export function MapPanel({
  phase,
  house,
  onEdit
}: MapPanelProps) {
  return <div className="relative isolate h-full w-full overflow-hidden rounded-[24px] bg-forest-deep" data-id="element-438" data-mp="2e5w66px7ag4o">
      <ScanMap house={house} data-id="element-439" data-mp="298cg8sr54eww" />

      {phase === 'scanning' && <div className="pointer-events-none absolute inset-0 z-[500] bg-forest-deep/35" aria-hidden="true" data-id="element-440" data-mp="295qcl47dejjy">
          <div className="absolute inset-0 opacity-30" style={{
        backgroundImage: 'linear-gradient(rgba(210,243,107,0.35) 1px, transparent 1px), linear-gradient(90deg, rgba(210,243,107,0.35) 1px, transparent 1px)',
        backgroundSize: '44px 44px'
      }} data-id="element-441" data-mp="2j5quclplcrm1" />
          <div className="scan-line absolute inset-x-0 top-0 h-[18%] border-b-2 border-volt bg-volt/10" data-id="element-442" data-mp="3oc0tp929yrgg" />
        </div>}

      {phase === 'idle' && <div className="pointer-events-none absolute inset-x-0 bottom-0 z-[500] p-5" data-id="element-443" data-mp="1xhgvgsy7kc3">
          <p className="w-fit rounded-full bg-canvas/90 px-4 py-2 text-[13px] text-ink-soft backdrop-blur" data-id="element-444" data-mp="1zvd3szd72l8">
            Vul je adres in om je woning op de luchtfoto te vinden
          </p>
        </div>}

      <AnimatePresence data-id="element-445" data-mp="3adb228y85jzh">
        {phase === 'result' && house && <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: 12
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="absolute inset-x-3 bottom-3 z-[500] sm:inset-x-5 sm:bottom-5" data-id="element-446" data-mp="3adkqhs3mfj32">
            <HouseCard house={house} onEdit={onEdit} data-id="element-447" data-mp="tr1esduqh8cm" />
          </motion.div>}
      </AnimatePresence>
    </div>;
}